<template>
	<div>
		<nav class="navbar navbar-toggleable navbar-expand-lg navbar-dark">
			<div class="container  ">
				<router-link to="/" class="navbar-brand ">
					<img
						class="navbar-brand__regular img-fluid d-lg-inline-block d-none"
						src="/assets/logo.png"
						alt="brand-logo"
						height="75px"
						width="75px"
					/>
					<img
						class="navbar-brand__sticky img-fluid  d-inline-block d-lg-none"
						src="/assets/logo.png"
						alt="sticky brand-logo"
						height="63px"
						width="63px"
					/>
				</router-link>

				<!--  End of brand logo -->
				<button
					class="navbar-toggler mr-0 "
					type="button"
					data-toggle="collapse"
					data-target="#navbar1"
				>
					<span class="navbar-toggler-icon"></span>
				</button>
				<!-- end of Nav toggler -->

				<!-- <nav> -->
				<div
					class="collapse navbar-collapse navbar-dark pr-0 pl-0 pl-lg-8  mr-0 ml-2 pl-sm-3"
					id="navbar1"
				>
					<ul class="navbar-nav" id="navbar-nav">
						<!-- <li class="nav-item dropdown">
							<router-link to="/" class="nav-link">{{
								$t("header.home")
							}}</router-link>
						</li> -->
						<!-- <li class="nav-item dropdown">
							<router-link to="/#suppliers" class="nav-link "
								>{{ $t("header.shops") }}
							</router-link>
						</li> -->
						<!-- <li class="nav-item dropdown">
							<router-link to="/blog" class="nav-link"
								>{{ $t("header.blog") }}
							</router-link>
						</li> -->
						<li class="nav-item dropdown">
							<router-link to="/#features" class="nav-link"
								>{{ $t("header.aboutUs") }}
							</router-link>
						</li>
						<li class="nav-item dropdown">
							<router-link to="/contact-us" class="nav-link"
								>{{ $t("header.contactUs") }}
							</router-link>
						</li>
					</ul>
					<!-- end of nav menu items -->
				</div>

				<div class="pr-4 pl-0 pr-lg-0 pl-lg-0">
					<!-- LOGIN -->

					<!-- COSTUMER NAME -->
					<span id="userFullName" class=" nav-item text-white"
						><router-link
							to="/customer"
							class="users_name font-size--13   font-w--400"
						>
							{{ getUsersFirstName + " " + getUsersLastName }}</router-link
						>
						|
						<button
							class="font-size--14   font-w--500 users_name"
							@click.prevent="logout"
						>
							خروج
						</button></span
					>
				</div>
				<!-- end of nav CTA button -->
			</div>
			<!-- end of container -->
		</nav>
	</div>
</template>

<script>
	export default {
		computed: {
			getUsersFirstName() {
				return this.$store.getters.getFirstName;
			},
			getUsersLastName() {
				return this.$store.getters.getLastName;
			}
		},
		methods: {
			logout: function() {
				this.$store.dispatch("logOut").then(() => {
					this.$router.push("/");
				});
			}
		}
	};
</script>

<style scoped>
	.navbar {
		position: fixed;
		/* height: 50px; */
		padding: 0 0 0 0 ;
    z-index: 1000;
		background: #272a33;
	}
	@media screen and (max-width:600px) {
		.navbar-toggler
		{
			left:0;
		}
		.navbar
		{
			position: absolute;
		}
		#userFullName
		{
			padding-left: 10px;
		}
		
	}
	

	.image {
		/* height: 700px; */
		opacity: 0.9;
		filter: blur(5px) contrast(110%) brightness(120%) sepia(50%);
		/* filter: blur(5px) grayscale(100%) sepia(100%) hue-rotate(90deg); */
	}
</style>
